import { setPostAutofillFocus, hiddenElementToggleCheck, isDate, parseDate, calculateAge, resetFormField, fillAddressFields, getPostcode, resetMonthlyOutgoingInputs, otfValidate, dobNumeric, setInputFocus, removeInputFocus, showAddressFields, resetAddressFields} from "./form-functions";

//Shared file between Thimbl loans and Thimbl card for all common JS functionality on each form.

//ADDRESS EVENT LISTENERS

$('.numeric-only').numeric();

// when the address option is selected check to see if any elements above the postcode field have no value and then set the focus to the field with no value
$('#addressSelect').change(function(){
    setPostAutofillFocus();
});

$(document).on('change', '[name=time_at_address]', function (event) {
    if (document.addressSelected === true) {
        if ($('[name=time_at_address]').val() < 12 && $('[name=time_at_address]').val() != '') { 
            if ($('[name=postcode_2]').val() == '') {
                $('.postcode_2-form-group, .need_address_2, .current-address-wrapper').slideDown('500');
                $('.postcode_2-form-group, .need_address_2, .current-address-wrapper').removeClass('hidden');
                $('.need_address_2').velocity("scroll", {
                    easing: "easeOutQuad",
                    offset: -20,
                    duration: 500,
                    delay: 100
                });
            }
        } else {
            $('[name=postcode_2]').removeClass('otf-pass');
            $('[name=postcode_2]').val('');
            $('.address-fields_2').find(':input').removeClass('otf-pass').val('');
            $('.address-fields_2').slideUp('500');
            $('.summary-2').html('');
            $('.postcode_2-form-group, .need_address_2').slideUp('500');
            $('.address_summary_2-form-group').addClass('hidden');
        }
    }
});

$('[name=addressSelect]').change(function () {
    var form = $(this).closest('form');
    fillAddressFields(this.value, $(this).closest('form'));
    $('.invalidAddress', form).remove();
    document.addressSelected = true;
    form.find('.findaddress-form-group').addClass('hidden');
    $('[name=time_at_address]').trigger('change');
});

$('[name=addressSelect_2]').change(function () {
    var form = $(this).closest('form');
    fillAddressFields(this.value, $(this).closest('form'), '_2');
    $('.invalidAddress_2', form).remove();
    document.addressSelected_2 = true;
    form.find('.findaddress-form-group_2').addClass('hidden');
});

$('[name=house], [name=address1], [name=address2], [name=town], [name=county], [name=postcode], [name=house_2], [name=address1_2], [name=address2_2], [name=town_2], [name=county_2], [name=postcode_2]').keyup(function (event) {
    var input = $(event.target);
    var form = input.closest('form');
    $('.invalidAddress', form).hide();
});

$(".find-address").click(function (e) {
    e.preventDefault();
    getPostcode($(e.target).closest('form'));
});

$("[name=postcode]").focusout(function (e) {
    e.preventDefault();
    var form = $(e.target).closest('form');
    if (!document.addressSelected) {
        getPostcode(form);
    }
});   

$(".find-address_2").click(function (e) {
    e.preventDefault();
    getPostcode($(e.target).closest('form'), '_2');
});

$("[name=postcode_2]").focusout(function (e) {
    e.preventDefault();
    var form = $(e.target).closest('form');
    // if (!document.addressSelected_2) {
        getPostcode(form, "_2");
    // }
});

$(".address-manual, .col-edit-button").click(function () {
    var suffix = $(this).attr('data-value');
    document.doNotUsePostcodeLookup = 1;
    showAddressFields(suffix);
});

$(".address-research, .col-replace-button").click(function () {
    var suffix = $(this).attr('data-value');
    resetAddressFields(suffix);
});

if ($('body').is('.form')) {
    $(document).on('keyup', '[name=postcode]', function (event) {
        if (event.keyCode === 13) {
            $(this).blur();
        }
        if (!$(this).is('.in')) {
            $(this).next('.find-address').addClass('in');
        }
    });
    $(document).on('keyup', '[name=postcode_2]', function (event) {
        if (event.keyCode === 13) {
            $(this).blur();
        }
        if (!$(this).is('.in')) {
            $(this).next('.find-address_2').addClass('in');
        }
    });
    $(document).on('click', '.use-mobile-button', function (event) {
        var target = $(event.currentTarget);
        var input = target.closest('.form-field').find('[name=home_phone], [name=employerphone]');
        var form = target.closest('form');
        var mobileNumber = form.find('[name=mobile]').val();
        input.val(mobileNumber).change();
        otfValidate(input.val(mobileNumber));
        $(this).hide();
    });
    // Show previous address click handling
    $(document).on('click', '.edit-address-button', function (event) {
        $('.address-fields').show();
        $('.current-address-wrapper').hide();
        $('.postcode-form-group').show();
    });

    //VALIDATION EVENT LISTENERS

    // Clear/Add 0 on focus/blur of input field with num-reset class
    $('.num-reset').on({
        focus: function () {
            if (this.value === '0') {
                this.value = '';
            };
        },
        blur: function () {
            $(this).closest('.form-field').addClass('currency-symbol');
            var previousVal = $('[name=loan_amount]').val();
            if ($(this).attr('name') != 'loan_amount') {
                if (this.value === '') {
                    this.value = '0';
                };
            } else {
                if ($('[name=loan_amount]').val() == '') {
                    $('[name=loan_amount]').val(previousVal);
                }
            }
        }
    });

    $('.consent-select').on('click',function () {
        var consentId = $(this).attr('id');
        var consentValue = $(this).attr('value');

        if ($(this).is('.consent-selected')) {
            window.amplitude.formConsentEvent('thimbl_' + consentId, 'Deselected ' + consentValue);
            document.querySelector('input[name=' + consentId + ']').value = "false";
            return $(this).removeClass('consent-selected').removeClass('otf-pass');
        }
        if (($(this).is('#email_consent') || $(this).is('#sms_consent')|| $(this).is('#whatsapp_consent')) && !$(this).hasClass("consent-selected")){
            document.querySelector('input[name=' + consentId + ']').value = "true";
        }
        $(this).addClass('consent-selected').addClass('otf-pass');
        // Amplitude event & properties
        window.amplitude.formConsentEvent('thimbl_' + consentId, 'Selected ' + consentValue);
    });

    // Date pickers
    $('.datepicker').datepicker({
        format: 'dd/mm/yyyy',
        startDate: '+1d',
        daysOfWeekDisabled: [0, 6],
        autoclose: true
    });
    // Extra info messaging
    $(document).on('keyup', function (event) {
        var target = $(event.target);
        var form = target.closest('form');
        var income = form.find('[name=income]');
        income = parseInt(income.length == 1 ? (income.val() || 0) : 0, 10);
        var outgoings = form.find('[name=outgoings]');
        outgoings = parseInt(outgoings.length == 1 ? (outgoings.val() || 0) : 0, 10);
        if (target.is('[name=income]') || target.is('[name=expenditure]')) {
            var income = form.find('[name=income]');
            income = parseInt(income.length == 1 ? (income.val() || 0) : 0, 10);
            var expenditure = form.find('[name=expenditure]');
            expenditure = parseInt(expenditure.length == 1 ? (expenditure.val() || 0) : 0, 10);
            // income above 4K
            if (target.is('[name=income]')) {
                $('.income-form-group').toggleClass('above-4k are-you-sure', income > 4000);
            }
            // Mortgage above 1K
            if (target.is('[name=expenditure]')) {
                $('.expenditure-form-group').toggleClass('above-1k are-you-sure', expenditure > 1000);
            }
            $('.outgoings-form-group').toggleClass('outgoings-more-than-incomings are-you-sure', outgoings > income);
        }
    });

    $('[name=income]').on('blur', function (event) {
        // young and low income
        var target = $(event.target);
        var form = target.closest('form');
        var income = form.find('[name=income]');
        income = parseInt(income.length == 1 ? (income.val() || 0) : 0, 10);
        if (income < 800 && window.age < 19) {
            $('#help-text-20').slideDown(250);
        } else {
            $('#help-text-20').slideUp(250);
        }
    });    

    $('[name=finance_breakdown]').change(function() {
        var financeBreakdown = $(this).val();
        window.toggleFinanceBreakdown(financeBreakdown === 'breakdown');
    });

    // On the fly validation
    $(".otf-val").change(function (event) {
        resetMonthlyOutgoingInputs();
        $(this).trigger('beforevalidate.digiloans');
        otfValidate($(this));
    });
}

if ($('body').is('.form') || $('body').is('.loans-home')) {
    $('.pseudo-select').click(function () {
        if ($(this).is('.locked')) {
            return false;
        }
        $(this).closest('.form-group').removeClass('error');
        $(this).parent().siblings('.pseudo-select-row').children('.pseudo-select').removeClass('pseudo-selected');
        $(this).siblings().removeClass('pseudo-selected');
        $(this).addClass('pseudo-selected');
        var form = $(this).closest('form');
        var formType = form.attr('action');
        var updateValue = $(this).attr('data-value');
        var updateField = $(this).closest('.form-field').attr('data-update-field');
        var element = $('[name=' + updateField + ']', form).val(updateValue).trigger('change');
        // datalayer eventProperties
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'form',
            'question': updateField,
            'validation': 'valid'
        });
        // Amplitude event & properties
        if (updateField !== 'term') {
            window.amplitude.formInteractionEvent(updateField, 'valid', '', formType);
        }

        hiddenElementToggleCheck(updateField, updateValue);
        resetFormField(element);
    });
    //if the term value has been set in local storage, trigger a click to the corresponding term circle.
    var termVal = localStorage.getItem("termVal");
    if (termVal) {
        $('.term-circle[data-value="' + termVal + '"]').removeClass('locked').trigger('click');
    }   
}

// Remove error message and class when fields are interacted with
$(document).on('keyup change', '[name=forename], [name=surname], [name=address1], [name=address2], [name=town], [name=county], [name=postcode], [name=address1_2], [name=address2_2], [name=town_2], [name=county_2], [name=postcode_2], [name=income], [name=expenditure], [name=title], [name=marital_status], [name=industry]', function (event) {
    var element = $(event.target);
    resetFormField(element);
});
$(document).on('keyup', '[name=email], [name=mobile], [name=home_phone], [name=house], [name=house_2], [name=job_title]', function (event) {
    var element = $(event.target);
    resetFormField(element);
});
$(document).on('change', '[name=terms_accepted]', function (e) {
    resetFormField('terms_accepted', 'Terms Accepted', null, $(this).closest('form'));
});

// DATE OF BIRTH EVENT LISTENERS
$(document).on('change', '[name=dob1], [name=dob2], [name=dob3]', function (event) {
    var el = $(event.target);
    var formGroup = el.closest('.form-group');
    var dob = formGroup.find('[name=dob]'),
        dob1 = formGroup.find('[name=dob1]'),
        dob2 = formGroup.find('[name=dob2]'),
        dob3 = formGroup.find('[name=dob3]');
    if (el.val() != '' && el.is('[name=dob1], [name=dob2]')) {
        var intVal = parseInt(el.val(), 10);
        if (intVal < 10 && el.val() != ('0' + intVal)) {
            el.val('0' + intVal);
        }
    }

    otfValidate(el);
    if (dob1.val() != '' && dob2.val() != '' && dob3.val() != '') {
        dob.val(dob1.val() + '/' + dob2.val() + '/' + dob3.val()).trigger('change');
    }
});

// Format DOB input with slashes and prevent letters
$(".numeric-with-slash").keydown(dobNumeric).keyup(function (e) {
    if (!e.ctrlKey && !e.metaKey && (e.keyCode == 32 || e.keyCode > 46)) dobFormat(e.target);
});

$("[name=dob1], [name=dob2], [name=dob3]").keyup(function (e) {
    e.preventDefault();
    var dobTargetField = $(event.target)[0];
    if (dobTargetField.value.length === 2 && dobTargetField.name === 'dob1') {
        setInputFocus(document.getElementsByName('dob2')[0]);
    }
    if (dobTargetField.value.length === 2 && dobTargetField.name === 'dob2') {
        setInputFocus(document.getElementsByName('dob3')[0]);
    }
    if (dobTargetField.value.length === 4 && dobTargetField.name === 'dob3') {
        removeInputFocus(dobTargetField);
    }
});

//Employment status change handler
$(document).on('change', '[name=employment_status]', function() { 
    var employmentStatusVal = $('[name=employment_status]').val();
    var showJobTitleArr = ['1', '2', '3'];
    if ($.inArray(employmentStatusVal, showJobTitleArr) >= 0) {
        $('.job_title-form-group').slideDown('500').removeClass('hidden');
        $('.employer_name-form-group').slideDown('500').removeClass('hidden');
    } else {
        $('.job_title-form-group').slideUp('500').addClass('hidden');
        $('.employer_name-form-group').slideUp('500').addClass('hidden');
    }
});

//Additional income
$(document).on('change', $('#other_income_input'), function() {
    if ($('#other_income_input').hasClass('pseudo-selected')) {
        $('.other-income-form-group').slideDown('500').removeClass('hidden');
    } else {
        $('.other-income-form-group').slideUp('500').addClass('hidden');
    }
});

// Dob
$(document).on('change', '[name=dob]', function (event) {
    var dobValue = $('[name=dob]').val();
    var dobText = $('.dob-age-text');
    var dobTipTextContainer = $('.dob-tip-text-wrapper');
    if (isDate($('[name=dob]').val())) {
        var age = calculateAge(parseDate($('[name=dob]').val()), new Date());
        window.age = age;
        if (matchMedia('(max-width: 768px)').matches) {
            $(dobTipTextContainer).hide();
        } else {
            $(dobTipTextContainer).show();
        }
        setTimeout(function () {
            $(".dob-age-text").removeClass('hidden');
        }, 500);
        $(".dob-age").text(age);
    }
    if (dobValue == '') {
        $(dobText).addClass('hidden');
    }
});

$(document).on('focusout', '[name=dob]', function (event) {
    var dobLabel = $('.dob-form-group .form-error').text();
    var errorMessage = $('dob-form-error-message');
    if (dobLabel == 'You must be 18 years or older*') {
        $(errorMessage).show();
    } else {
        $(errorMessage).hide();
    }
});

//set the faq accordion default to be hidden
$('.faq-accordion').hide();

$(document).on('click', '#money-help-debt-advice', function (event) {
    window.amplitude.debtAdviceClick();
});

$(document).on('click', '#stepchange-clickout', function (event) {
    window.amplitude.stepchangeClickout();
});

$(document).on('click', '#moneyhelper-clickout', function (event) {
    window.amplitude.moneyhelperClickout();
});

// Check to see if email is valid and provide a hint suggestion if not
var $email = $('[name=email]');
var $hint = $('#email-hint-1');
$email.on('blur', function () {
    $hint.css('display', 'none').empty();
    $(this).mailcheck({
        suggested: function (element, suggestion) {
            if (!$hint.html()) {
                // First error - fill in/show entire hint element
                var suggestion = "Did you mean <span class='suggestion'>" +
                    "<a href='#' class='domain'><span class='address'>" + suggestion.address + "@</span>" +
                    suggestion.domain + "</a></span>?";

                $hint.html(suggestion).fadeIn(150);
            } else {
                // Subsequent errors
                $(".address").html(suggestion.address);
                $(".domain").html(suggestion.domain);
            }
        }
    });
});
$hint.on('click', '.domain', function () {
    // When anchor is clicked populate field and hide hint suggestion
    $email.val($(".suggestion").text());
    otfValidate($email);
    $hint.fadeOut(200, function () {
        $(this).empty();
    });
    return false;
});